import * as React from 'react';

import { cn } from '@/lib/utils';

/*
 * Restyled to ScreenAtlas tokens (web/docs/ui-ux.md §5):
 * - the border is the input's job (borders are the exception, not the system);
 *   separation from the canvas comes from the raised `surface` fill.
 * - only the inset highlight hairline (`shadow-highlight`, ui-ux.md §2
 *   "Material") — no drop shadow; the focus ring is the app-wide :focus-visible outline
 *   (index.css) — do not add per-component rings.
 * - invalid fields get a danger border AND a text error beside them
 *   (errors are announced, not colour-only — ui-ux.md §8).
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded border border-border bg-surface px-3.5 text-body text-ink shadow-highlight',
          'transition-[border-color,background-color] duration-150 ease-out',
          'hover:border-ink-tertiary focus-visible:border-info',
          'placeholder:text-ink-tertiary disabled:cursor-not-allowed disabled:opacity-50',
          'aria-[invalid=true]:border-danger',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
